<template>
  <a-layout-header class="header gongsiheader" :style="{ background: '#FFF','margin-bottom':'10px' }">
    <a-image
  :width="40"
  src="https://img.alicdn.com/imgextra/i1/698818285/O1CN01PHKt922B4a2zYyLaj_!!698818285.png"
  class="gongsilogo"

    />
    <a-typography-text class="gongsiname" >商鱼交易</a-typography-text>
    <a-typography-text class="loginnick" >登录店铺：<span>{{ shopname }}</span></a-typography-text>
    <a href="https://fuwu.jinritemai.com/detail?service_id=20954" target="_blank">续费</a>
  </a-layout-header>
	<div id="xianshiloging" :style="jiazaiorguanbilogingstr">
		<a-spin size="large"/>
	</div>
</template>

<script>
window.shopinfoObj = {}
import { defineComponent, ref } from "vue"; 
import { getMainShop } from '@/request/api';
import { useRouter } from 'vue-router';
export default defineComponent ({
  setup(){
    const router = useRouter()
  },
  created(){
    const url = location.href;
	window.jiazaiorguanbiloging = this.jiazaiorguanbiloging;
    if(url.indexOf("https://zb.huolangcloud.com.cn") < 0){
      this.getShopName()
    }
  },
  data(){
    return{
		shopname:'',
		jiazaiorguanbilogingstr:'display:none;'
    }
  },
  methods:{
	jiazaiorguanbiloging(status){
		if(status == true){
			this.jiazaiorguanbilogingstr = 'display: block;z-index: 100;position: fixed;top: 280px;left: 50%;'
		}else {
			this.jiazaiorguanbilogingstr = 'display:none;'
		}
	},
    getShopName(){
      getMainShop().then(res => {
        this.shopname = res.data;
        window.shopinfoObj = res
		let keys = 'subAcc_list';	
		const promise = new Promise((resolve, reject) => {
			let subAcc_listobj = localStorage.getItem(keys);
			resolve(subAcc_listobj)
		});
		promise.then(subAcc_listobj => {
			if(typeof(subAcc_listobj) == 'string'){
				let subAcc_list = JSON.parse(subAcc_listobj)
				let itemkey = res.shopId + '_' + res.toutiaoId;
				subAcc_list[itemkey] = res	
				localStorage.setItem(keys,JSON.stringify(subAcc_list));	
			}else {
				let itemkey = res.shopId + '_' + res.toutiaoId;
				let obj = {}
				obj[itemkey] = res;
				localStorage.setItem(keys,JSON.stringify(obj));
			}		
		})
      })
    }
  }
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#components-layout-demo-top-side-2 .logo {
  float: left;
  width: 120px;
  height: 31px;
  margin: 16px 24px 16px 0;
  background: rgba(255, 255, 255, 0.3);
  
}

.ant-row-rtl #components-layout-demo-top-side-2 .logo {
  float: right;
  margin: 16px 0 16px 24px;
}

.site-layout-background {
  background: #fff;
}
.loginnick{
  margin-right:  24px;
  margin-left:  48px;
}
</style>
